import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Stack, Drawer } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
import useCollapseDrawer from '../../../hooks/useCollapseDrawer';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Scrollbar from '../../../components/Scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';

// routes
import { DOCS } from '../../../routes/paths';
// components
// import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';
//
import NavbarAccount from './NavbarAccount';
import CollapseButton from './CollapseButton';



// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const { isCollapse, collapseClick, collapseHover, onToggleCollapse, onHoverEnter, onHoverLeave } =
    useCollapseDrawer();
    const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;
    const ICONS = {
      user: getIcon('ic_user'),
      transaction: getIcon('transaction'),
      buy_cable: getIcon('adex_cable'),
      calendar: getIcon('ic_calendar'),
      buy_data: getIcon('adex_data'),
      buy_airtime: getIcon('adex_phone'),
      dashboard: getIcon('adex_home'),
      fund: getIcon('fund'),
      phone: getIcon('phone'),
      stock: getIcon('stock'),
      setting: getIcon('setting'),
      wallet: getIcon('wallet'),
      cal: getIcon('cal'),
    };


      // nav bar  
     const  navConfig =  [
   {
  subheader: 'Developed By A.D.E developers',
  items: [
    { title: 'home', path: DOCS.root, icon: ICONS.dashboard },
    { title: 'data vending', path: DOCS.buydata, icon: ICONS.buy_data },
    { title: 'airtime vending', path: DOCS.buyairtime, icon: ICONS.buy_airtime },
    { title: 'cable sub vending', path: DOCS.buycable, icon: ICONS.buy_cable },
    {title: 'bill vending', path: DOCS.buybill, icon: ICONS.buy_cable},
    {title: 'exam vending', path: DOCS.buyexam, icon: ICONS.buy_cable},
    {title: 'bulksms vending', path: DOCS.bulksms, icon: ICONS.buy_cable},
    {title: 'verify IUC', path: DOCS.verifyiuc, icon: ICONS.buy_cable},
    {title: 'verify METER', path: DOCS.verifymetter, icon: ICONS.buy_cable},
    {title: 'data-card', path: DOCS.data_card, icon: ICONS.buy_cable},
    {title: 'recharge-card', path: DOCS.recharge_card, icon: ICONS.buy_cable},
    {title: 'webhook integration', path: DOCS.webhook, icon: ICONS.buy_cable},
    
     ],
},
 ]


  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' }),
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Logo />

          {isDesktop && !isCollapse && (
            <CollapseButton onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
          )}
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack>
        <NavSectionVertical navConfig={navConfig} isCollapse={isCollapse} />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: 'absolute',
        }),
      }}
    >
      {!isDesktop && (
        <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}>
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: 'dashed',
              bgcolor: 'background.default',
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
